import * as React from "react";
import type { SVGProps } from "react";
const SvgIconTemperature = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#clip0_6129_18727)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.83.82C5.63.96 4.55 1.83 4.16 3c-.18.5-.16.05-.17 5.27v4.7l-.26.2c-.29.22-.68.6-.89.87-1.38 1.73-1.64 4.07-.67 6.03.83 1.68 2.4 2.81 4.25 3.1.4.05 1.21.05 1.6 0 1.23-.2 2.33-.74 3.19-1.6 1.43-1.44 1.99-3.56 1.44-5.51-.26-.9-.75-1.75-1.41-2.43-.2-.2-.63-.57-.74-.63-.03-.02-.04-.54-.04-4.72 0-4.42-.01-4.72-.05-4.88q-.22-.94-.83-1.57c-.74-.77-1.7-1.12-2.75-1m8.13 0c-.22.06-.44.25-.55.48-.06.11-.07.16-.07.35 0 .2 0 .23.08.37q.16.31.45.43c.1.04.23.05.55.07.22.01.51.04.64.06 1.52.25 2.85 1.1 3.72 2.4.21.32.5.92.63 1.3.17.51.28 1.14.28 1.58q-.01.71.52.94c.12.06.17.07.34.07q.34 0 .58-.23c.23-.2.3-.45.28-.91-.06-1.1-.3-2-.77-2.93q-.52-1.06-1.35-1.88C19.07 1.69 17.5.96 15.76.82q-.57-.05-.8 0M6.85 2.57q-.39.1-.7.41c-.21.22-.3.37-.4.66-.05.12-.05.33-.06 5.08l-.01 4.96-.05.11c-.09.18-.22.3-.55.52-.73.48-1.31 1.23-1.57 2.04-.13.37-.17.65-.19 1.08-.02.42 0 .67.1 1.05.31 1.4 1.43 2.53 2.83 2.9.62.15 1.33.15 1.95 0q.98-.27 1.73-.98.98-.93 1.17-2.3c.05-.35.04-.95-.04-1.3q-.35-1.62-1.8-2.56-.33-.22-.44-.45l-.05-.11-.01-4.96c-.01-4.75-.01-4.96-.06-5.08-.1-.29-.2-.47-.4-.67-.16-.15-.25-.21-.4-.29l-.33-.12c-.17-.04-.57-.03-.72 0m8.09 2.25q-.36.12-.54.47c-.05.11-.06.17-.06.35s.01.24.06.35c.04.08.12.2.18.26.18.17.3.22.65.25.5.06.73.16 1.03.46s.41.56.46 1.1c.03.27.09.41.25.57.18.18.35.25.6.25.17 0 .22-.01.35-.07q.29-.15.43-.43c.07-.14.07-.17.07-.45-.02-1.21-.79-2.37-1.92-2.86-.51-.23-1.25-.35-1.56-.25M6.98 15.94c-.68.09-1.25.64-1.38 1.32-.07.4 0 .86.2 1.17.36.54.9.82 1.52.79.68-.04 1.25-.48 1.48-1.13.06-.17.07-.23.07-.5q0-.3-.05-.45c-.14-.53-.57-.98-1.1-1.14-.2-.06-.53-.1-.74-.06"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6129_18727">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconTemperature;
